import React from 'react'
import Header from '../Header/Header'
import Row from '../Row/Row'
import { getSettingsIcon } from '../../data/settingsIcons'
import s from './Main.module.scss'

export const Main = ({
	activeNotifications,
	notificationsLoadStatus,
	sections = [],
	academicYearLabel,
	academicYearMetaStatus,
	goToView,
	onOpenParentCommunication,
}) => {
	const handleRowClick = row => {
		if (row.action === 'parentCommunication') {
			onOpenParentCommunication()
			return
		}
		if (row.view) {
			goToView(row.view)
		}
	}

	const resolveMeta = row => {
		if (row.metaKey === 'activeNotifications') {
			if (notificationsLoadStatus !== 'success') {
				return '…'
			}
			return `${activeNotifications} on`
		}
		if (row.metaKey === 'academicYearLabel') {
			if (academicYearMetaStatus !== 'success') {
				return '…'
			}
			return academicYearLabel || null
		}
		return row.meta || null
	}

	return (
		<>
			<Header
				title="Settings"
				description="Manage communication, notifications and support."
			/>
			{sections.map(section => (
				<section key={section.id} className={s.main__section}>
					<h2 className={s.main__title}>{section.title}</h2>
					<div className={s.main__group}>
						{section.rows.map(row => (
							<Row
								key={row.id}
								icon={getSettingsIcon(row.iconKey)}
								title={row.title}
								subtitle={row.subtitle}
								meta={resolveMeta(row)}
								tone={row.tone}
								onClick={() => handleRowClick(row)}
							/>
						))}
					</div>
				</section>
			))}
		</>
	)
}

export default Main
